import React from 'react';

function LoginPromptModal({ showLoginPrompt, setShowLoginPrompt, loginPromptMessage, user, setPage }) {
  
  if (!showLoginPrompt) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '32px',
        maxWidth: '450px',
        width: '90%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <h2 style={{ margin: '0 0 16px 0', color: '#1e293b', fontSize: '22px' }}>
          {user ? 'Upgrade Required' : 'Registration Required'}
        </h2>
        <p style={{ color: '#475569', lineHeight: '1.6', marginBottom: '24px' }}>
          {loginPromptMessage}
        </p>
        <div style={{ display: 'flex', gap: '12px' }}>
          {user ? (
            <>
              <button
                onClick={() => { setShowLoginPrompt(false); alert('Upgrade feature coming soon!'); }}
                style={{
                  flex: 1,
                  padding: '12px 24px',
                  backgroundColor: '#f59e0b',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Upgrade Now
              </button>
              <button
                onClick={() => setShowLoginPrompt(false)}
                style={{
                  flex: 1,
                  padding: '12px 24px',
                  backgroundColor: '#f1f5f9',
                  color: '#334155',
                  border: '1px solid #cbd5e1',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Maybe Later
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => { setShowLoginPrompt(false); setPage('register'); }}
                style={{
                  flex: 1,
                  padding: '12px 24px',
                  backgroundColor: '#0369a1',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Register Free
              </button>
              <button
                onClick={() => { setShowLoginPrompt(false); setPage('login'); }}
                style={{
                  flex: 1,
                  padding: '12px 24px',
                  backgroundColor: '#f1f5f9',
                  color: '#334155',
                  border: '1px solid #cbd5e1',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Log In
              </button>
            </>
          )}
        </div>
        {!user && (
          <button
            onClick={() => setShowLoginPrompt(false)}
            style={{
              width: '100%',
              marginTop: '12px',
              padding: '10px',
              backgroundColor: 'transparent',
              color: '#64748b',
              border: 'none',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            Maybe Later
          </button>
        )}
      </div>
    </div>
  );
}

export default LoginPromptModal;
